import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import useMultiSelectionLayout from '../../../hooks/useMultiSelectionLayout';
import { ALIGN_TO_CANVAS } from '../../../utils/computeMultiSelectionLayoutUpdates';
import { useStore } from '../../../hooks';
import { TABS_IDS, WATERMARK_ANNOTATION_ID } from '../../../utils/constants';
import SidebarPanelButton from '../SidebarPanelButton';
import { AlignCenter, AlignMiddle } from '../../../utils/editorReactIcons';

const CANVAS_ALIGN_ACTIONS = [
  {
    id: ALIGN_TO_CANVAS.CENTER_HORIZONTAL,
    titleKey: 'alignCanvasCenterHorizontalTitle',
    labelKey: 'alignCanvasCenterHorizontalShort',
    Icon: AlignCenter,
  },
  {
    id: ALIGN_TO_CANVAS.CENTER_VERTICAL,
    titleKey: 'alignCanvasCenterVerticalTitle',
    labelKey: 'alignCanvasCenterVerticalShort',
    Icon: AlignMiddle,
  },
];

const SelectionCanvasAlignControls = ({ className = '' }) => {
  const { t, tabId, selectionsIds = [], annotations = {} } = useStore();
  const { alignToCanvas, canAlignToCanvas } = useMultiSelectionLayout();

  const hasAlignableSelection = selectionsIds.some(
    (id) =>
      id !== WATERMARK_ANNOTATION_ID && !annotations[id]?.locked,
  );

  const handleAction = useCallback(
    (alignment) => {
      if (canAlignToCanvas) {
        alignToCanvas(alignment);
      }
    },
    [alignToCanvas, canAlignToCanvas],
  );

  if (tabId !== TABS_IDS.ANNOTATE || !hasAlignableSelection) {
    return null;
  }

  return (
    <div
      className={`respark_canvas-align-controls respark_inspector-option-row ${className}`.trim()}
      role="group"
      aria-label={t('alignCanvasTitle')}
    >
      {CANVAS_ALIGN_ACTIONS.map((action) => (
        <div
          key={action.id}
          className="respark_inspector-option-row-cell"
        >
          <SidebarPanelButton
            className={`respark_canvas-align-btn respark_canvas-align-btn--${action.id}`}
            Icon={action.Icon}
            label={t(action.labelKey)}
            title={t(action.titleKey)}
            disabled={!canAlignToCanvas}
            onClick={() => handleAction(action.id)}
          />
        </div>
      ))}
    </div>
  );
};

SelectionCanvasAlignControls.propTypes = {
  className: PropTypes.string,
};

export default SelectionCanvasAlignControls;
